import React, { useState, useEffect } from 'react';
import { Container, Card, Image, Grid, Header, Icon, Button, Loader, Message } from 'semantic-ui-react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import api from '../../api';
import AgentCard from './AgentCard';
import './styles.scss';

const AgentsList = () => {
    const [agents, setAgents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchAgents = async () => {
            try {
                setLoading(true);
                const response = await api.agent.getAgents();

                if (response.statusCode === 200 && response.result?.data) {
                    setAgents(response.result.data);
                } else {
                    setError('No agents found.');
                }
            } catch (err) {
                setError('An error occurred while loading agents.');
                console.error('Agents fetch error:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchAgents();
    }, []);

    if (loading) {
        return (
            <Container style={{ paddingTop: '2rem', textAlign: 'center' }}>
                <Loader active size="large" />
                <p>Loading agents...</p>
            </Container>
        );
    }

    if (error) {
        return (
            <Container style={{ paddingTop: '2rem' }}>
                <Message negative>
                    <Message.Header>Error</Message.Header>
                    <p>{error}</p>
                </Message>
            </Container>
        );
    }

    return (
        <>
            <Helmet>
                <title>Real Estate Agents in Malta | Easy Rent Malta Team</title>
                <meta name="description" content="Meet our professional team of real estate agents in Malta. Our experts are dedicated to helping you find the perfect property for rent or sale." />
                <meta name="keywords" content="real estate agents malta, property agents malta, easy rent malta team" />
            </Helmet>

            <Container style={{ paddingTop: '2rem' }}>
                {/* Page Header */}
                <div className="page-header">
                    <Header as="h1" className="page-title">
                        <Icon name="users" className="icon-color" />
                        Our Real Estate Agents
                    </Header>
                    <p className="page-subtitle">
                        Meet our professional team of real estate experts who are here to help you find your perfect property.
                    </p>
                </div>

                {/* Agents Grid */}
                {agents.length === 0 ? (
                    <Message info>
                        <Message.Header>No Agents Found</Message.Header>
                        <p>There are currently no agents available.</p>
                    </Message>
                ) : (
                    <div className="agents-grid">
                        <Grid>
                            <Grid.Row>
                                {agents.map((agent) => (
                                    <Grid.Column
                                        key={agent.id}
                                        width={16}
                                        computer={4}
                                        tablet={8}
                                        mobile={16}
                                    >
                                        <AgentCard agent={agent} />
                                    </Grid.Column>
                                ))}
                            </Grid.Row>
                        </Grid>
                    </div>
                )}

                {/* Call to Action */}
                <div className="cta-section">
                    <Card fluid className="cta-card">
                        <Card.Content textAlign="center">
                            <Header as="h2" className="icon-color">
                                <Icon name="phone" />
                                Need Help Finding the Right Agent?
                            </Header>
                            <p>
                                Our team is here to help you find the perfect property. Contact us today for personalized assistance.
                            </p>
                            <Button
                                className="green-btn"
                                size="large"
                                as={Link}
                                to="/contact"
                                icon="mail"
                                content="Contact Us"
                            />
                        </Card.Content>
                    </Card>
                </div>
            </Container>
        </>
    );
};

export default AgentsList;
